import { render, staticRenderFns } from "./acpm-procedimiento-editar.vue?vue&type=template&id=715dfb45&"
import script from "./acpm-procedimiento-editar.vue?vue&type=script&lang=js&"
export * from "./acpm-procedimiento-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports